export let wods = [
  {
    name: "Tabata something else",
    description:
      "Four Tabatas in 16 minutes\n- Tabata Pull-Ups \n- Tabata Push-Ups\n- Tabata Sit-Ups\n- Tabata Air Squats",
    type: "tabata",
    url: "/?t=tabata&p=10&c=10&n=TABATA+SOMETHING+ELSE&d=Four+Tabatas+in+16+minutes%0ATabata+Pull-Ups%0ATabata+Push-Ups%0ATabata+Sit-Ups%0ATabata+Air+Squats%0A%0Ahttps%3A%2F%2Fwodwell.com%2Fwod%2Ftabata-something-else&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Pull-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Push-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Sit-Ups%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10&r=Air+Squats%3B20%3B10",
  },
  {
    name: "Chelsea",
    description: "- 5 pull-ups\n- 10 push-ups\n- 5 squats",
    type: "emom",
    url: "/?t=emom&p=10&c=10&n=Chelsea&d=-+5+pull-ups%0A-+10+push-ups%0A-+5+squats&r=round+1%3B60&r=round+2%3B60&r=round+3%3B60&r=round+4%3B60&r=round+5%3B60&r=round+6%3B60&r=round+7%3B60&r=round+8%3B60&r=round+9%3B60&r=round+10%3B60&r=round+11%3B60&r=round+12%3B60&r=round+13%3B60&r=round+14%3B60&r=round+15%3B60&r=round+16%3B60&r=round+17%3B60&r=round+18%3B60&r=round+19%3B60&r=round+20%3B60&r=round+21%3B60&r=round+22%3B60&r=round+23%3B60&r=round+24%3B60&r=round+25%3B60&r=round+26%3B60&r=round+27%3B60&r=round+28%3B60&r=round+29%3B60&r=round+30%3B60",
  },
  {
    name: "Cindy",
    description: "- 5 pull-ups\n- 10 push-ups\n- 15 squats",
    type: "amrap",
    url: "/?t=amrap&p=10&c=10&n=Cindy&r=1200&d=-+5+pull-ups%0A-+10+push-ups%0A-+15+squats",
  },
  {
    name: "Murph",
    description:
      "- 1 mile run\n- 100 pull-ups\n- 200 push-ups\n- 300 air squats\n- 1-mile run",
    type: "rft",
    url: "/?t=rft&p=10&n=Murph&d=1+mile+run%0A100+pull-ups%0A200+push-ups%0A300+air+squats%0A1-mile+run",
  },
  {
    name: "Fran",
    description: "21-15-9 reps for time\n- 95 lb thruster\n- Pull-ups",
    type: "rft",
    url: "/?t=rft&p=10&n=Fran&d=21-15-9+reps+for+time%0A95+lb+thruster%0APull-ups",
  },
  {
    name: "Clovis",
    description:
      "- Run 10 miles\n- 150 burpee pull-ups\nPartition the run and burpee pull-ups as needed",
    type: "rft",
    url: "/?t=rft&p=10&n=Clovis&d=-+Run+10+miles%0A-+150+burpee+pull-ups%0APartition+the+run+and+burpee+pull-ups+as+needed",
  },
  {
    name: "Nick",
    description:
      "12 rounds for time\n- 45 lb dumbbell hang squat clean, 10 reps\n- 6 handstand push-ups on dumbbells\nhttps://www.youtube.com/watch?v=OI7HmNhoB8U",
    type: "rft",
    url: "/?t=rft&p=10&n=Nick&d=12+rounds+for+time%0A-+45+lb+dumbbell+hang+squat+clean%2C+10+reps%0A-+6+handstand+push-ups+on+dumbbells%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DOI7HmNhoB8U",
  },
  {
    name: "Grace",
    description:
      "30 clean and jerks for time\nMen: 135 lb\nWomen: 95 lb\nhttps://www.youtube.com/watch?v=fO6QQaMIDhg",
    type: "rft",
    url: "/?t=rft&p=10&n=Grace&d=30+clean+and+jerks+for+time%0AMen%3A+135+lb%0AWomen%3A+95+lb%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DfO6QQaMIDhg",
  },
  {
    name: "Karen",
    description:
      "150 wallball shots – 20lb ball\nhttps://www.youtube.com/watch?v=zH8Lfk4jgH4",
    type: "rft",
    url: "/?t=rft&p=10&n=Karen&d=150+wallball+shots+%E2%80%93+20lb+ball%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DzH8Lfk4jgH4",
  },
  {
    name: "Hansen",
    description:
      "5 rounds for time of:\n- 30 kettlebell swings\n- 30 burpees\n- 30 GHD sit-ups",
    type: "rft",
    url: "http://localhost:5000/?t=rft&p=10&n=Hansen&d=5+rounds+for+time+of%3A%0A-+30+kettlebell+swings%0A-+30+burpees%0A-+30+GHD+sit-ups",
  },
  {
    name: "Bert",
    description:
      "- 50 burpees & 400m run\n- 100 push-ups & 400m run\n- 150 walking lunges & 400m run\n-200 squats & 400m run\n- 150 walking lunges & 400m run\n- 100 push-ups & 400m run\n- 50 burpees\nhttps://www.youtube.com/watch?v=n6ejYI_tWTI",
    type: "rft",
    url: "/?t=rft&p=10&n=Bert&d=-+50+burpees+%26+400m+run%0A-+100+push-ups+%26+400m+run%0A-+150+walking+lunges+%26+400m+run%0A-200+squats+%26+400m+run%0A-+150+walking+lunges+%26+400m+run%0A-+100+push-ups+%26+400m+run%0A-+50+burpees%0A%0Ahttps%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3Dn6ejYI_tWTI",
  },
  {
    name: "Big Mama tabata",
    description:
      "Four Tabatas in 16 minutes:\n- Wall Ball Shots (20/14 lb)\n- Toes to Bars\n- Row (Calories)\n- Power Cleans (135/95 lb)\nhttps://wodwell.com/wod/big-mama-tabata/",
    type: "tabata",
    url: "/?t=tabata&p=10&c=10&n=BIG+MAMA+TABATA&d=Four+Tabatas+in+16+minutes%3A%0A-+Wall+Ball+Shots+%2820%2F14+lb%29%0A-+Toes+to+Bars%0A-+Row+%28Calories%29%0A-+Power+Cleans+%28135%2F95+lb%29%0A%0Ahttps%3A%2F%2Fwodwell.com%2Fwod%2Fbig-mama-tabata%2F&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Wall+Ball+Shots%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Toes+to+Bars%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Row%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10&r=Power+Cleans%3B20%3B10",
  },
];
